export const EXEC_EMAILS = [
    "president@cissa.org.au",
    "secretary@cissa.org.au",
    "treasurer@cissa.org.au",
    "v.president@cissa.org.au"
]